import { jsx as _jsx } from "react/jsx-runtime";
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import * as React from 'react';
import { TimezoneContext } from '../date-picker/provider';
import { fromMomentToZonedDateTime, toMoment, useDateSlotProps } from '../date-picker/utils';
import { TextField } from '../textfield';
import { DESKTOP_MEDIA_QUERY } from '../theme';
import { withVersion } from '../utils';
export const TimePicker = withVersion((props) => {
    const { timezone } = React.useContext(TimezoneContext);
    const { value, minTime, maxTime, onChange, skeleton, size = 'small', width = '100%', ...muiProps } = props;
    const slotProps = useDateSlotProps({
        ...props,
        size,
        width
    });
    if (skeleton) {
        return _jsx(TextField, { width: width, skeleton: true });
    }
    return (_jsx(MuiTimePicker, { minutesStep: 5, ...muiProps, ...slotProps, desktopModeMediaQuery: DESKTOP_MEDIA_QUERY, sx: { width: '100%', ...muiProps.sx }, value: toMoment.nullable(value), minTime: toMoment(minTime), maxTime: toMoment(maxTime), onChange: (date) => {
            onChange?.(fromMomentToZonedDateTime(date, timezone));
        } }));
}, '1.0.0');
